import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "confirm-overlay"
}
const _hoisted_2 = { class: "confirm-card" }
const _hoisted_3 = { class: "confirm-title" }
const _hoisted_4 = { class: "confirm-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "link link-inline confirm-link",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, _toDisplayString(_ctx.buttonText), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}